import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";

class WizardPage extends Component {
  static propTypes = {
    /** Object which holds wizard data (probably from a form) */
    data: PropTypes.object,
    /** Right, "primary" button */
    affirmButtonText: PropTypes.string,
    /** Left, "secondary" button */
    rejectButtonText: PropTypes.string,
    /** Boolean for whether the affirm button is disabled */
    isDisabled: PropTypes.bool,
    /** Callback when navigating to a prev step */
    handlePrevStep: PropTypes.func,
    /** Callback when navigating to a next step */
    handleNextStep: PropTypes.func,
  };

  static defaultProps = {
    data: {},
    rejectButtonText: "Back",
    affirmButtonText: "Next",
    isDisabled: true,
    handlePrevStep: () => null,
    handleNextStep: () => null,
  };

  render() {
    return (
      <div className="et-wizard-page">
        <div className="et-wizard--body">{this.props.children}</div>
        <div className="et-wizard--footer">
          <Button type="secondary" onClick={() => this.props.handlePrevStep()}>
            {this.props.rejectButtonText}
          </Button>
          <Button disabled={this.props.isDisabled} onClick={() => this.props.handleNextStep()}>
            {this.props.affirmButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

export default WizardPage;
